module.exports = __webpack_public_path__ + "images/zoom_landing_footer.jpg";


//////////////////
// WEBPACK FOOTER
// ./vively/images/zoom_landing_footer.jpg
// module id = 861
// module chunks = 3